import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as personalInfoActions from 'actions/dashboard/personalInfo';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';

// let loaded = false;
const initialState = {
  loaded: false,
  personGroupLoaded: false,
};

export const withPersonalInfo = (WrappedComponent) => {
  class WithPersonalInfo extends BaseHOC {
    state = { ...initialState };

    async componentDidMount() {
      const { getPersonalInfo } = this.props;
      if (!this.state.loaded) {
        await getPersonalInfo();
        this.setState({ ...initialState, loaded: true });
        // loaded = true;
      }
    }

    getPersonalInfoByPersonGroup = async () => {
      const { getPersonalInfo } = this.props;
      if (!this.state.personGroupLoaded) {
        const personGroupData = await getPersonalInfo({
          filter_by_person_group: 'true',
        });
        this.setState((prev) => ({ ...prev, personGroupLoaded: true }));
        return personGroupData;
      } else {
        // Return cached data if already loaded
        return await getPersonalInfo({ filter_by_person_group: 'true' });
      }
    };

    getPersonalInfoByAllPersons = async () => {
      const { getPersonalInfo } = this.props;
      if (!this.state.personGroupLoaded) {
        const personsData = await getPersonalInfo({
          filter_by_person_group: 'false',
        });
        this.setState((prev) => ({ ...prev, personGroupLoaded: true }));
        return personsData;
      } else {
        // Return cached data if already loaded
        return await getPersonalInfo({ filter_by_person_group: 'false' });
      }
    };

    get personalInfoOptions() {
      const { personalInfo } = this.props;
      return personalInfo.data.map(({ id, ...rest }) => {
        return {
          id,
          name: `${rest.first_name} ${rest.last_name}`,
        };
      });
    }

    deletePersonalInfoById = async (data) => {
      const { deletePersonalInfoById } = this.props;
      await this._deleteById(deletePersonalInfoById, data, 'person');
    };

    deleteBulkPersonalInfo = async (data) => {
      const { deleteBulkPersonalInfo } = this.props;
      await this._deleteBulk(deleteBulkPersonalInfo, data, 'person');
    };

    getFullName = (person) => {
      return person ? `${person.last_name} ${person.first_name}` : '';
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          loaded={this.state.loaded}
          personalInfoOptions={this.personalInfoOptions}
          getPersonalInfoByPersonGroup={this.getPersonalInfoByPersonGroup}
          getPersonalInfoByAllPersons={this.getPersonalInfoByAllPersons}
          deleteBulkPersonalInfo={this.deleteBulkPersonalInfo}
          deletePersonalInfoById={this.deletePersonalInfoById}
          getFullName={this.getFullName}
        />
      );
    }
  }
  const mapStateToProps = ({ personalInfo }) => ({ personalInfo });
  const PersonalInfo = connect(
    mapStateToProps,
    personalInfoActions,
  )(WithPersonalInfo);
  hoistNonReactStatics(PersonalInfo, WrappedComponent);
  return compose(withBaseHOCProps)(PersonalInfo);
};
